'use client';

import { Button } from '@galapagos/design-system/web';
import { useTranslation } from 'react-i18next';
import { useSignupNavigation } from '../../hooks/useSignupNavigation';
import { useStepHeading } from '../../hooks/useStepHeading';
import { gated } from './gated';
import { WrapUpActions, WrapUpFrame } from './WrapUpFrame';
import { WRAP_UP_PICTURES, WrapUpPicture } from './WrapUpPicture';

/** `/rewards-points/`: the points a member earns for the welcome call. */
function RewardsPointsStep() {
  const { t } = useTranslation('signup');
  const title = t('wrapUp.rewardsPoints.title');
  const headingRef = useStepHeading(title);
  const { goToStep } = useSignupNavigation();
  return (
    <WrapUpFrame
      title={title}
      description={t('wrapUp.rewardsPoints.pointsLine')}
      headingRef={headingRef}
    >
      <WrapUpPicture
        tone="grey"
        size="phone"
        src={WRAP_UP_PICTURES.welcomeCall}
        data-testid="signup-rewards-points-picture"
      />
      <WrapUpActions>
        <Button
          size="L"
          type="Primary"
          label={t('wrapUp.rewardsPoints.continue')}
          actionId="signup.rewards-points-continue.activate"
          data-testid="signup-rewards-points-continue-button"
          onPress={() => goToStep('call-choice')}
        />
      </WrapUpActions>
    </WrapUpFrame>
  );
}

export const RewardsPointsScreen = gated(RewardsPointsStep, 'rewards-points');
